import URLS from '@/store/urls';
import apiCall from '@/store/apiCall';

const createUploadFile = (file, folder = 'frame-display-images') => {
  const blobBin = atob(file.split(',')[1]);
  const array = [];
  for (let i = 0; i < blobBin.length; i += 1) {
    array.push(blobBin.charCodeAt(i));
  }
  const data = new Blob([new Uint8Array(array)], { type: 'image/png' });
  const formData = new FormData();
  formData.append('file', data);
  formData.append('folder', folder);
  return apiCall({
    type: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    url: URLS.fileUpload,
    body: formData,
    isToken: true,
  });
};

export default createUploadFile;
